// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"293":"itamat","333":"party","353":"contact","389":"404","539":"misc","594":"about","609":"faq"}[chunkId] + "." + {"293":"72848054","333":"d387f0f8","353":"51a06f8b","389":"08babe11","539":"0faece64","594":"15742dce","609":"2854dc02"}[chunkId] + ".css";
};